import { useState } from "react"

import { 
  Collapse, 
  IconButton 
} from "@mui/material";
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'; 
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { styled } from '@mui/material/styles';

const HelpTextExpand = (props) => {
  const { expand, ...other } = props;
  return ( 
    <IconButton {...other}>
      <HelpOutlineOutlinedIcon  /> 
    </IconButton>
  );
}

export const HelpText = ({text, buttonStyle}) => {
  const [expanded, setExpanded] = useState(false);

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };
  
  return (
    <>
      <HelpTextExpand
        style={buttonStyle}
        expand={expanded}
        onClick={handleExpandClick}
        aria-expanded={expanded}
        aria-label="show more"
      />
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <span style={{fontSize: "small"}}> {text}</span>
        <IconButton
            aria-label="expand row"
            size="small"
            onClick={ handleExpandClick }
          >
            <KeyboardArrowUpIcon />
          </IconButton>
      </Collapse>
    </>
  )
}


const ReadMoreExpand = styled((props) => {
  const { expand, ...other } = props;
  return ( 
    <>
      <IconButton {...other}>
        <InfoOutlinedIcon  /> 
      </IconButton>
    </>
  );
})(({ theme, expand }) => ({
  color: "#4d8dc1",
  transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)', 
  marginLeft: 'auto',
  transition: theme.transitions.create('transform', {
   duration: theme.transitions.duration.shortest,
  }),
}));

export const ReadMore = ({text, buttonStyle}) => {
  const [expanded, setExpanded] = useState(false);

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };
  
  return (
    <>
      <ReadMoreExpand
          style={buttonStyle}
          expand={expanded}
          onClick={handleExpandClick}
          aria-expanded={expanded}
          aria-label="show more"
        >
      </ReadMoreExpand>
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <span style={{fontSize: "small"}}> {text}</span>
        <IconButton
            aria-label="expand row"
            size="small"
            onClick={ handleExpandClick }
          >
            <KeyboardArrowUpIcon />
          </IconButton>
      </Collapse>
    </>
  )
}